import axios from "axios";

export const apiPublic = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL + "/auth",
  headers: {
    "Content-Type": "application/json",
  },
});
